<div class="view-core-firmware-version__container">

  <div class="view-core-firmware-version__container__header-container">
    <dcc-page-title class="view-core-firmware-version__container__header-container__header" title="Version Details"></dcc-page-title>
    <div class="view-core-firmware-version__container__header-container__close"
         (click)="close()"><i class="lx-icon lx-close-x"></i></div>
  </div>

  <div class="view-core-firmware-version__container__body">

    <content-with-label label="Version Name">
      <div class="lx-body">{{firmwareVersion?.name}}</div>
    </content-with-label>

    <content-with-label label="Version">
      <div class="lx-body">{{firmwareVersion?.version}}</div>
    </content-with-label>

    <content-with-label label="Build">
      <div class="lx-body">{{firmwareVersion?.build}}</div>
    </content-with-label>

    <content-with-label label="Created Date">
      <div class="lx-body">{{firmwareVersion?.createdDate}}</div>
    </content-with-label>

    <content-with-label label="Platform">
      <div class="lx-body">{{firmwareVersion?.platformType}}</div>
    </content-with-label>

  </div>
</div>

<div class="view-core-firmware-version__button-container">
  <button class="view-core-firmware-version__button-container__button lx-btn lx-btn-secondary"
          (click)="close()">Close</button>
</div>
